import React from 'react';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import Card from 'dashboard/components/card/Card.js';

export default function Profile(props) {
  const { name, domain, email, logo, profilePcture, ...rest } = props;
  const src = profilePcture || logo;
  // No bottom margin: the column this sits in sets the gaps, and a card that
  // also sets one makes the space under it twice the space under its
  // neighbours.
  return (
    <Card {...rest}>
      <Stack direction='row' alignItems='center'>
        <Avatar src={src} sx={{ width: 87, height: 87, mr: '20px' }} />
        <Box>
          <Typography variant='h5' fontWeight='bold'>{name}</Typography>
          <Typography variant='body2' color='text.secondary' mt='1px'>
            {domain ? domain : email}
          </Typography>
        </Box>
      </Stack>
    </Card>
  );
}
